export const MEASUREMENT_DATE_ACTION_ADD = 'add';
export const MEASUREMENT_DATE_ACTION_DELETE = 'delete';
